import { render, staticRenderFns } from "./paidBonusManagement.vue?vue&type=template&id=8dc39526&scoped=true&"
import script from "./paidBonusManagement.vue?vue&type=script&lang=ts&"
export * from "./paidBonusManagement.vue?vue&type=script&lang=ts&"
import style0 from "./paidBonusManagement.vue?vue&type=style&index=0&id=8dc39526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc39526",
  null
  
)

export default component.exports